import React from 'react'
import { Icon, ScreenReaderOnly, UnstyledButton } from '@chilipiper/design-system'
import { SvgArrowLeft } from '@chilipiper/icons/src/arrow'
import '../prospect-form.css'

interface Props {
  onBack: () => void
}

export const Back = ({ onBack }: Props) => {
  return (
    <UnstyledButton
      onClick={onBack}
      className='fabe-close-icon'
      data-test-id='change-booking-time-icon'
      mr={2}
    >
      <ScreenReaderOnly>Change Booking time</ScreenReaderOnly>
      <Icon
        alt='Change Booking time'
        className='fa fa-chevron-left'
        w={6}
        h={6}
        color='neutral-dark-80'
        icon={SvgArrowLeft}
      />
    </UnstyledButton>
  )
}
